import React from 'react';
import { Trans } from 'react-i18next';
import { H3, Subtitle } from 'react-design-components';
import { Box } from '@material-ui/core';
import useHelp from './hooks/useHelp';

const PeriodHelp = () => {
  const { t } = useHelp();
  return (
    <Trans i18nKey="period" t={t}>
      <Box mb={3}>
        <H3>Abrechnungszeitraum</H3>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Durch Angabe des genauen Abrechnungszeitraumes lässt sich ermitteln, ob Ihr Vermieter sich an
          <b>alle gesetzlichen Fristen</b>
          gehalten hat.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Der Abrechnungszeitraum ist die
          <b>Zeitspanne,</b>
          für die die Nebenkostenabrechnung erstellt wurde. Dieser darf maximal 12 Monate betragen und geht meistens vom
          1. Januar bis 31. Dezember aus.
        </Subtitle>
      </Box>
      <Box mb={2}>
        <Subtitle>
          Wurden Fristen seitens Ihres Vermieters nicht eingehalten, kann es sein, dass Sie einer eventuellen
          Nachzahlungsforderung nicht nachkommen müssen. Ausstehendes Guthaben würde Ihnen dennoch weiter zustehen.
        </Subtitle>
      </Box>
    </Trans>
  );
};

export default PeriodHelp;
